import { Box, Button, Form } from '@domain-group/suit-theme'

import EntitySelector from '@components/EntitySelector'

import useCreditNoteItem, { useCreditNoteItemForm } from '@hooks/useCreditNoteItem'
import { ModalCallbacks } from '@modals/CreateOrEditCreditNoteModal'

import type { CampaignQuoteItemModel, CreditNoteItemModel } from '@models/types'

const AddCreditNoteItem = (props: {
  callbacks: ModalCallbacks,
  creditNoteItem: Partial<CreditNoteItemModel>,
}) => {
  const { callbacks, creditNoteItem } = props
  const { createCreditNoteItem } = callbacks

  const creditNoteItemForm = useCreditNoteItemForm(creditNoteItem, { validateOn: 'change' })
  const {
    entityState,
    entityState: {
      description,
      price,
    },
    handlers,
    saveEnabled,
    setEntityState,
  } = creditNoteItemForm

  const creditNoteItemPayload = useCreditNoteItem(creditNoteItem)
  const {
    callbacks: { createCreditNoteItem: createFn },
    // @ts-expect-error TS2339
    creditNote: { campaign_id },
    creating,
  } = creditNoteItemPayload

  const createCreditNoteItemPayload = {
    callbacks: {
      action: createFn,
      afterAction: () => setEntityState({
        description: '',
        price: 0,
      }),
    },
    entityParams: entityState,
    toastText: 'Credit Note Item Added',
  }

  return (
    <Box flexDirection="column" flexShrink="0" paddingY="large">
      <EntitySelector
        callbacks={{
          // @ts-expect-error TS2322
          selectItem: (campaignQuote: CampaignQuoteItemModel) => setEntityState({
            // @ts-expect-error TS2339
            description: campaignQuote.text,
            price: campaignQuote.price_override || campaignQuote.price,
          }),
        }}
        entityKey="campaignQuoteItems"
        label="Search Quote Items"
        secondaryTextKey="formatted_price"
        searchRequestOptions={{
          campaign_id,
          selected: true,
        }}
      />

      <Form.Field label="Item Description" marginTop="large">
        <input name="description" value={description} type="text" {...handlers} />
      </Form.Field>

      <Form.Field label="Price" marginTop="large">
        <Box>
          <input name="price" value={price} type="number" {...handlers} />

          <Button
            buttonStyle="primaryCreate"
            disabled={!saveEnabled}
            loading={creating}
            // @ts-expect-error
            marginLeft="medium"
            onClick={() => createCreditNoteItem(createCreditNoteItemPayload)}
            size="medium"
            width="auto"
          >
            Add Item
          </Button>
        </Box>
      </Form.Field>
    </Box>
  )
}

export default AddCreditNoteItem
